import { HOST_APP_DEFAULT_PROD_URL, HOST_APP_PROD_HOSTS, META_APP_NAMES } from './consts'

import type { AppEnvMap, AppEnvConfig } from '@zto/zpage'
import type { KtHostAppEnv } from './typings'

export const HOST_APP_HOSTS = {
  DEV: '127.0.0.1:3110',
  TEST: 'admin.txyypt.ft.ztosys.com',
  TEST_B: 'admin-b.txyypt.ft.ztosys.com',
  TEST_G: 'admin-g.txyypt.ft.ztosys.com',
  PRE: 'kt.txyypt.re.ztosys.com'
}

// 通用环境变量
const CommonEnv = {
  appNs: 'tuxi-operate',
  requestSource: 'pc', // 请求标识为pc，和小程序及其他平台区分
  scmClientSource: 97
  // scmHeaders: { 'x-dubbo-tag': '' }, // 供应链请求头
}

// 通用测试环境变量
export const TestEnv: AppEnvConfig<KtHostAppEnv> = {
  ...CommonEnv,
  isProdZcat: false, // zcat环境 false测试环境
  appId: 'ztTTO4riBbTJvMwRgRxkOhh7',
  hostUrl: `http://${HOST_APP_HOSTS.TEST}`,
  apiUrl: 'http://localhost:8082/pc',
  // apiUrl: 'http://10.10.132.155:8082',
  scmUrl: 'https://zscm.gw-test.ztosys.com',
  iamUrl: 'http://iam-web.test.ztosys.com',
  fsUrl: 'https://fs.test.ztosys.com',
  fsUrlOperate: 'https://file-storage.gw-test.ztosys.com',
  fsAppId: 'DFS1423110276329549825',
  bmapAK: 'wNTd8CTuMxXocI36R4BtDUnTDQxLsAkL',

  appEntries: {
    [META_APP_NAMES.DATA_CENTER]: 'https://tuxi-data.test.ztosys.com', // 数据中台
    [META_APP_NAMES.DATA_CENTER2]: 'https://tuxi-data.test.ztosys.com', // 数据中台
    [META_APP_NAMES.CONFIG_CENTER]: 'https://kt-config.test.ztosys.com', // 配置中台
    [META_APP_NAMES.KDCS_OPERATE]: 'https://kt-kdcs.test.ztosys.com', // 快超运营
    [META_APP_NAMES.AD_OPERATE]: 'https://kt-ad.test.ztosys.com', // 广告运营
    [META_APP_NAMES.DMS_OPERATE]: 'https://kt-txsh.test.ztosys.com', // 兔个乐运营
    [META_APP_NAMES.YLPT_OPERATE]: 'https://kt-ylpt.test.ztosys.com', // 运力平台
    [META_APP_NAMES.IOT_OPERATE]: 'https://test-tuxi-iot-web-dme.test.ztosys.com', // Iot运营
    [META_APP_NAMES.ZSCMKDG_OPERATE]: 'https://test-zscm-kdg-operate-web-dme.test.ztosys.com', // 快递柜供应链
    [META_APP_NAMES.ABOSS_OPERATE]: 'https://test-boss-operate-web-dme.test.ztosys.com' // 合作商管理
  }
}

// 开发环境变量
export const DevEnv: AppEnvConfig<KtHostAppEnv> = {
  ...TestEnv,
  hostUrl: `http://${HOST_APP_HOSTS.DEV}`
}

// 通用生产环境变量
export const ProdEnv: AppEnvConfig<KtHostAppEnv> = {
  ...CommonEnv,
  isProdZcat: true, // zcat环境 true生产环境
  appId: 'ztuhE4j1TmlC9lrkth9kkWck',
  hostUrl: HOST_APP_DEFAULT_PROD_URL,
  apiUrl: 'https://tuxi-operate.gw.zt-express.com',
  scmUrl: 'https://opsmc-api.zto.com',
  iamUrl: 'https://iam-web.zto.com',
  fsUrl: 'https://fs.zto.com',
  fsUrlOperate: 'https://file-storage.gw.zt-express.com',
  fsAppId: 'ztRw1tpgIaUwyvT3ukoGXItQ',
  bmapAK: 'wNTd8CTuMxXocI36R4BtDUnTDQxLsAkL',

  appEntries: {
    [META_APP_NAMES.DATA_CENTER]: 'https://data.tuxi.com', // 数据中台
    [META_APP_NAMES.DATA_CENTER2]: 'https://data.tuxi.com', // 数据中台
    [META_APP_NAMES.CONFIG_CENTER]: 'https://config-operate.tuxi.com', // 配置中台
    [META_APP_NAMES.KDCS_OPERATE]: 'https://kdcs-operate.tuxi.com', // 快超运营
    [META_APP_NAMES.AD_OPERATE]: 'https://ad-operate.tuxi.com', // 广告运营
    [META_APP_NAMES.DMS_OPERATE]: 'https://dms-operate.tuxi.com', // 兔个乐运营
    [META_APP_NAMES.YLPT_OPERATE]: 'https://ylpt-operate.tuxi.com', // 运力平台
    [META_APP_NAMES.IOT_OPERATE]: 'https://kt-iot.tuxi.com', // Iot运营
    [META_APP_NAMES.ZSCMKDG_OPERATE]: 'https://zscm-kdg-admin.tuxi.com', // 快递柜供应链
    [META_APP_NAMES.ABOSS_OPERATE]: 'https://agent-admin.tuxi.com' // 兔喜合作商管理
  }
}

// 预发环境变量
export const PreEnv: AppEnvConfig<KtHostAppEnv> = {
  ...ProdEnv,
  hostUrl: `http://${HOST_APP_HOSTS.PRE}`,
  extraHeaders: { 'x-dubbo-tag': 'pre' },

  appEntries: {
    [META_APP_NAMES.DATA_CENTER]: 'https://data-pre.tuxi.com', // 数据中台
    [META_APP_NAMES.DATA_CENTER2]: 'https://data-pre.tuxi.com', // 数据中台
    [META_APP_NAMES.CONFIG_CENTER]: 'http://config.kdcs.re.ztosys.com', // 配置中台
    [META_APP_NAMES.KDCS_OPERATE]: 'http://operate.kdcs.re.ztosys.com', // 快超运营
    [META_APP_NAMES.AD_OPERATE]: 'http://ad-operate.mdjcxxgl.re.ztosys.com', // 广告运营
    [META_APP_NAMES.DMS_OPERATE]: 'http://dms-operate.mdjcxxgl.re.ztosys.com', // 兔个乐运营
    [META_APP_NAMES.YLPT_OPERATE]: 'http://operate.ylpt.re.ztosys.com', // 运力平台
    [META_APP_NAMES.IOT_OPERATE]: 'https://kt-iot.stg.ztosys.com', // Iot运营
    [META_APP_NAMES.ZSCMKDG_OPERATE]: 'https://zscm-kdg-admin.stg.ztosys.com', // 快递柜供应链
    [META_APP_NAMES.ABOSS_OPERATE]: 'https://agent-admin.stg.ztosys.com' // 兔喜合作商管理
  }
}

export const envMap: AppEnvMap<KtHostAppEnv> = {
  dev: {
    // 开发/本地环境
    HOSTs: [HOST_APP_HOSTS.DEV],
    ENV: {
      ...DevEnv,
      // extraHeaders: { 'x-dubbo-tag': 'txyyptv0977dev' } // 本地开发时，需要增加此x-dubbo-tag为对应版本的“空间标签”（从一站式当前版本获取）
    }
  },
  test: {
    // 测试环境
    HOSTs: [HOST_APP_HOSTS.TEST],
    ENV: { ...TestEnv }
  },

  test_b: {
    // 测试环境(蓝)
    HOSTs: [HOST_APP_HOSTS.TEST_B],
    ENV: {
      ...TestEnv,
      hostUrl: `http://${HOST_APP_HOSTS.TEST_B}`,
      extraHeaders: { 'x-dubbo-tag': 'blue' }
    }
  },

  test_g: {
    // 测试环境(绿)
    HOSTs: [HOST_APP_HOSTS.TEST_G],
    ENV: {
      ...TestEnv,
      hostUrl: `http://${HOST_APP_HOSTS.TEST_G}`,
      extraHeaders: { 'x-dubbo-tag': 'green' }
    }
  },

  pre: {
    // 预发布环境
    HOSTs: [HOST_APP_HOSTS.PRE],
    ENV: { ...PreEnv }
  },

  prod: {
    // 生产环境
    HOSTs: HOST_APP_PROD_HOSTS,
    ENV: { ...ProdEnv }
  }
}
